import { ProfileTypes } from '@api/Users/User';
export const getProfileName = (profile?: ProfileTypes) => {
    switch (profile) {
        case ProfileTypes.Admin:
            return 'Admin';
        case ProfileTypes.BranchAdmin:
            return 'Admin de sucursal';
        case ProfileTypes.Manager:
            return 'Gerente';
        case ProfileTypes.Collaborator:
            return 'Colaborador';
        case ProfileTypes.DistributionCenter:
            return 'Centro de Distribución';
        default:
            return '';
    }
};
